import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, actions, Errors } from 'react-redux-form';
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from "../common/page-title/index";
import InlineCKEditor from "../common/editor/inline-editor";
import RequiredPasswordMaskInput from '../common/form/elements/required-password-mask-input';
import ArrowButton from '../common/button-arrow';
import ErrorMessages from '../login/error-messages';
import { updateMyPassword } from '../../actions/update-password';
import { loadPageContent } from "../../actions/content";

import './update-password.css';

const PAGE_SLUG_UPDATE_PASSWORD = 'update-password';

class UpdatePassword extends Component {

  componentWillMount() {
    this.props.dispatch(loadPageContent(`api/pages/${PAGE_SLUG_UPDATE_PASSWORD}`));
  }

  updateErrors = (field, value) => {
    this.setState({ [field]: value });
  };

  onChangeMyPasswordClicked = (payload) => {
    this.props.dispatch(actions.submitFields('deep.updatePw.user', updateMyPassword(payload)));
  };

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${PAGE_SLUG_UPDATE_PASSWORD}`));
  };

  render() {
    return (
      <Grid className="update-password wrapper">
        <Row>
          <Col lg={12}>
            <PageTitle>Update password</PageTitle>
          </Col>
          <Col lg={12} className="description">
            <InlineCKEditor
              identifier={`${PAGE_SLUG_UPDATE_PASSWORD}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={this.props.contents[`${PAGE_SLUG_UPDATE_PASSWORD}_content_text`]}
            />
          </Col>
        </Row>
        <Form
          model="deep.updatePw.user"
          onSubmit={this.onChangeMyPasswordClicked}
        >
          <Errors
            className="errors"
            model="deep.updatePw.user"
            component={ErrorMessages}
            show={{ touched: true, focus: false }}
          />
          <Row>
            <Col lg={6}>
              <RequiredPasswordMaskInput
                model=".current_password"
                label="Current Password"
                controlId="currentPassword"
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <RequiredPasswordMaskInput
                model=".password"
                label="New Password"
                controlId="newPassword"
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <RequiredPasswordMaskInput
                model=".password_confirmation"
                label="Confirm New Password"
                controlId="confirmNewPassword"
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <ArrowButton
                color="red"
                className="pull-right"
                arrow={false}>
                Change my password
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.viewConfig.profile,
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(UpdatePassword);



// WEBPACK FOOTER //
// ./src/components/update-password/index.jsx